module.exports = __webpack_public_path__ + "img/third-image.841a9c98.png";